export default "__VITE_ASSET__BxQAR$JB__"